import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { NotifierService } from "angular-notifier";
import { LoggingService } from "src/app/services/logging.service";
import { LoginService } from "src/app/services/login.service";
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { SidePanelService } from "../services/side-pannel/side-pannel.service";
import { VersionCheckService } from "src/app/core/services/version-check.service";


@Component({
  selector: "app-login-popup",
  templateUrl: "./login-popup.component.html",
  styleUrls: ["./login-popup.component.scss"],
})
export class LoginPopupComponent implements OnInit, OnDestroy {
  public errorText = null;
  public hide: boolean = true;
  public userEmail: string = "";
  public userOtpPass: string = "";
  public errorSocialLogin: boolean = false;
  private accessRoles: any;

  constructor(
    public LoginService: LoginService,
    private notifier: NotifierService,
    private LoggingService: LoggingService,
    private router: Router,
    private sidePanelService: SidePanelService,
    private versionCheckService: VersionCheckService,
    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {}

  ngOnInit(): void { 
    console.log(this.LoginService.loginBtnControl);
    this.setLoginVariablesOnOpen();
  }

  ngOnDestroy(): void {
    this.setLoginVariablesOnClose();
  }

  setLoginVariablesOnClose() {
    this.LoginService.loginBtnControl.btnOff = true;
    this.LoginService.loginBtnControl.btnLogin = false;
    this.LoginService.loginBtnControl.loginPassword = false;
    this.LoginService.loginBtnControl.loginOtp = false;
    this.LoginService.loginBtnControl.hideOtpResend = true;
    this.LoginService.loginBtnControl.showOtpResend = false;
    this.LoginService.loginBtnControl.isUnKnownUser = false;
    this.errorText = null;
    this.hide = true;
    this.userEmail = "";
    this.userOtpPass = "";
    this.errorSocialLogin = false;
    this.accessRoles = undefined;
  }

  setLoginVariablesOnOpen() {
    this.setLoginVariablesOnClose();
    let userStorageEmail = localStorage.getItem('user_login_email');
    if(userStorageEmail) {
      this.userEmail = userStorageEmail;
    }
  }

  onclickPassword() {
    if (this.userEmail && this.userEmail != "" && this.validateEmail()) {
      this.LoginService.verfiyUser(this.userEmail, "loginPassword");
    } else if(this.userEmail && this.userEmail != "" && !this.validateEmail()) {
      this.notifier.notify("error", "Please enter a Valid email ID");
    } else {
      this.notifier.notify("error", "Please enter email ID");
    }
  }

  onOtpResend() {
    this.userOtpPass = "";
    setTimeout(() => {
      this.onclickOtp();
    }); 
  }

  onclickOtp() {
    if (this.userEmail && this.userEmail != "" && this.validateEmail()) {
      this.LoginService.verfiyUser(this.userEmail, "loginOtp");
    } else if(this.userEmail && this.userEmail != "" && !this.validateEmail()) {
      this.notifier.notify("error", "Please enter a Valid email ID");
    } else {
      this.notifier.notify("error", "Please enter email ID");
    }
  }

  login() {
    if (
      this.LoginService.loginBtnControl.loginPassword &&
      !this.LoginService.loginBtnControl.loginOtp
    ) {
      this.LoggingService.logInfo(this.userEmail);
      this.LoginService.loginPassword(this.userEmail, this.userOtpPass)
        .pipe(
          map((data) => {
            if (data.message == "Success") {
              this.accessRoles = JSON.parse(localStorage.getItem("access"));
              if (
                this.accessRoles.org_id ==
                "d69b3bb6-3133-11e9-8d02-42010aa0000d"
              ) {
                localStorage.setItem("isITC", "1");
              }
              localStorage.setItem('user_login_email',this.userEmail);
              this.setLoginVariablesOnClose();
              this.LoginService.onPopopLoginEvent.emit();
              this.reloadCurrentPage();
            } else {
              this.errorText = "Email and password do not match";
            }
          })
        )
        .subscribe((data) => {});
    }
    if (
      this.LoginService.loginBtnControl.loginOtp &&
      !this.LoginService.loginBtnControl.loginPassword
    ) {
      this.LoggingService.logInfo(this.userEmail);
      this.LoginService.loginOtp(this.userEmail, this.userOtpPass)
        .pipe(
          map((data) => {
            if (data.message == "Success") {
              this.accessRoles = JSON.parse(localStorage.getItem("access"));
              if (
                this.accessRoles.org_id ==
                "d69b3bb6-3133-11e9-8d02-42010aa0000d"
              ) {
                localStorage.setItem("isITC", "1");
              }
              localStorage.setItem('user_login_email',this.userEmail);
             
              this.setLoginVariablesOnClose();
              this.LoginService.onPopopLoginEvent.emit();
              setTimeout(() => {
                this.LoginService.getTermAndCond().subscribe((data) =>{
                  if(data.status){
                    this.LoginService.termandCondType = data.type || '';
                    this.router.navigate(['/tnc']);
                  }else{
                    const {redirect} = window.history.state;
                    console.log("Redirect URL: ", redirect);
                    const redirectUrl = localStorage.getItem('redirectUrl');
                    this.sidePanelService.checkGuestAccountAccess();
                    if(redirect && !redirect.includes('login')) {
                      this.reloadCurrentPage();
                    }else if(redirectUrl) {
                      this.redirectToLocalStorageUrl(redirectUrl);
                    }else{
                      this.router.navigate(['/home-dashboard']);
                    }
                    this.versionCheckService.checkVersionOnLogin();
                  }
                })
              });

           
             
            } else {
              this.errorText = data.message;
            }
          })
        )
        .subscribe((data) => {});
    }
  }

  microsoftLogin() {
    this.errorSocialLogin = false;
    let baseUrl = window.location.origin;
    let windowLoginUrl;
    switch (baseUrl){
      case 'https://research.crownit.in':
        windowLoginUrl = 'https://reports.crownit.in';
        break;
      case 'https://research.eagleinsights.in':
        windowLoginUrl = 'https://reports.eagleinsights.in';
        break;
      default:
        windowLoginUrl = environment.apiUrl;
        break;
    }   
    windowLoginUrl += '/auth/sso/login';
    console.log('windowLoginUrl',windowLoginUrl);
    var loginwindow = window.open(windowLoginUrl,"mywindow","location=1,status=1,scrollbars=1, width=800,height=800");
    if (!loginwindow || loginwindow.closed || typeof loginwindow.closed == 'undefined') {
      console.log('Popup blocked or failed to open');
    } else {
      console.log('Popup opened successfully');
    }
    let listener = window.addEventListener("message", (message) => {
      if (message.data.responseCode == 1) {
        localStorage.setItem("access",JSON.stringify(message.data.userDetails));
        this.LoggingService.logInfo(message.data.message);
        this.accessRoles = JSON.parse(localStorage.getItem("access"));
        if (this.accessRoles.org_id == "d69b3bb6-3133-11e9-8d02-42010aa0000d") {
          localStorage.setItem("isITC", "1");
        }
        this.setLoginVariablesOnClose();
        this.LoginService.onPopopLoginEvent.emit();
        setTimeout(() => {
          loginwindow.close();
          this.LoginService.getTermAndCond().subscribe((data) =>{
            if(data.status){
              this.LoginService.termandCondType = data.type || '';
              this.router.navigate(['/tnc']);
            }else{
              const {redirect} = window.history.state;
              console.log("Redirect URL: ", redirect);
              const redirectUrl = localStorage.getItem('redirectUrl');
              if(redirect && !redirect.includes('login')) {
                this.reloadCurrentPage();
              }else if(redirectUrl) {
                this.redirectToLocalStorageUrl(redirectUrl);
              }else{
                this.router.navigate(['/home-dashboard']);
              }
              this.versionCheckService.checkVersionOnLogin();
            }
          })
        })
    
        this.LoginService.clearLocalStorageEmail();
      }
      if(message.data.responseCode == 0){
        this.notifier.notify('error', message.data.message);
        loginwindow.close();
        this.errorSocialLogin = true;
      }  
      
   
    });
  }

  clearError() {
    if (this.LoginService.loginBtnControl.isUnKnownUser) {
      this.LoginService.loginBtnControl.isUnKnownUser = false;
    }
    this.errorText = null;
  }

  passwordInputFocus(elem: HTMLInputElement) {
    console.log("Input focused");
    elem.hasAttribute("readonly") && elem.removeAttribute("readonly");
    elem.select();
  }

  btnBack() {
    this.LoginService.loginBtnControl.loginOtp = false;
    this.LoginService.loginBtnControl.loginPassword = false;
    this.LoginService.loginBtnControl.hideOtpResend = true;
    this.LoginService.loginBtnControl.showOtpResend = false;
    this.LoginService.loginBtnControl.btnLogin = false;
    this.LoginService.loginBtnControl.btnOff = true;
    this.errorText = null;
    clearInterval(this.LoginService.intervalCall);
  }

  validateEmail = () => (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.userEmail));

  reloadCurrentPage(){
    let currentUrl = this.router.url;
    console.log("Current URL: ", currentUrl);
    this.LoginService.setSideDrowerEvent.emit();
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  redirectToLocalStorageUrl(redirectUrl?: string) {
    if (redirectUrl) {
      this.LoginService.onPopopLoginEvent.emit();
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        setTimeout(() => {
          this.router.navigateByUrl(redirectUrl);
        }, 0);
      });
      localStorage.removeItem('redirectUrl');
    }
  }
}